"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRenderCellViews = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@nextui-org/react");
var react_2 = require("react");
var copy_text_1 = require("../../../../../../components/copy_text");
function ImageCellView(_a) {
    var cellValue = _a.cellValue;
    return ((0, jsx_runtime_1.jsx)(react_1.User, { avatarProps: {
            radius: "lg",
            src: cellValue,
        }, classNames: {
            name: "text-default-foreground",
            description: "text-default-500",
        }, name: "" }));
}
function IdCellView(_a) {
    var cellValue = _a.cellValue;
    return (0, jsx_runtime_1.jsx)(copy_text_1.CopyText, { children: String(cellValue) });
}
function NameCellView(_a) {
    var cellValue = _a.cellValue;
    return (0, jsx_runtime_1.jsx)("div", __assign({ className: "text-small text-default-foreground" }, { children: cellValue }));
}
function FileNameCellView(_a) {
    var cellValue = _a.cellValue;
    return (0, jsx_runtime_1.jsx)("div", __assign({ className: "text-small text-default-foreground" }, { children: "".concat((Number(cellValue) / 1024 / 1024).toFixed(2), " MB") }));
}
function CategoryCellView(_a) {
    var cellValue = _a.cellValue;
    return (0, jsx_runtime_1.jsx)("div", __assign({ className: "text-small capitalize text-default-foreground" }, { children: cellValue !== null && cellValue !== void 0 ? cellValue : "N/A" }));
}
function TagsCellView(_a) {
    var cellValue = _a.cellValue;
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "flex flex-wrap gap-1" }, { children: cellValue === null || cellValue === void 0 ? void 0 : cellValue.map(function (tag) { return ((0, jsx_runtime_1.jsx)(react_1.Chip, __assign({ size: "sm", variant: "flat", className: "text-xs" }, { children: tag }), tag)); }) })));
}
function useRenderCellViews() {
    var renderCellViews = (0, react_2.useCallback)(function (cellValue, record) {
        var commonTextStyles = "text-small capitalize text-default-foreground";
        var nowrapTextStyles = "text-nowrap text-small capitalize text-default-foreground";
        return [
            {
                key: "url",
                content: (0, jsx_runtime_1.jsx)(ImageCellView, { cellValue: cellValue }),
            },
            {
                key: "file_name",
                content: (0, jsx_runtime_1.jsx)(NameCellView, { cellValue: cellValue }),
            },
            {
                key: "file_type",
                content: (0, jsx_runtime_1.jsx)(NameCellView, { cellValue: cellValue }),
            },
            {
                key: "file_size",
                content: (0, jsx_runtime_1.jsx)(FileNameCellView, { cellValue: cellValue }),
            },
            {
                key: "product_count",
                content: (0, jsx_runtime_1.jsx)(NameCellView, { cellValue: cellValue }),
            },
            // {
            //   key: "category",
            //   content: <CategoryCellView cellValue={cellValue} />,
            // },
            // {
            //   key: "tags",
            //   content: <TagsCellView cellValue={cellValue} />,
            // },
        ];
    }, []);
    return {
        renderCellViews: renderCellViews,
    };
}
exports.useRenderCellViews = useRenderCellViews;
